<template>
  <div class="progress-conponent" :style="{ left: `${diff}px` }">
    <div class="progress-line-container">
      <div
        v-for="p in porgressLine"
        :key="p.id"
        :class="p.status"
        class="progress-line"
      ></div>
    </div>
    <div class="progress-circle-container">
      <div
        v-for="p in circleArr"
        :key="p.text"
        class="progress-item"
        ref="progressItems"
        :class="p.status"
      >
        <div class="circle-border">
          <div class="circle"></div>
        </div>
        <div class="status-text">{{ p.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "CancelPlanProgressComponent",
  props: {
    array: {
      type: Array,
      default: () => [
        { text: "Feedback", active: true },
        { text: "Detail", active: true },
        { text: "Offer", active: false },
      ],
    },
  },
  data() {
    return {
      diff: 0, // 为了保持居中的相对便宜
    };
  },
  computed: {
    porgressLine() {
      let result = [];
      this.array.forEach((item, index) => {
        // 第一项不做判断
        if (index !== 0) {
          // 判断当前项是否为激活状态，如果是则当前项和前一项之间的连线为实体
          let status = "unactive";
          if (item.active) {
            status = "active";
          }
          result.push({
            id: index,
            status,
          });
        }
      });
      return result;
    },
    circleArr() {
      return this.array.map((item, index) => {
        let status = "unactive";
        if (item.active) {
          // 如果当前处于激活状态则判断当前项是否为最后的激活项
          const lastActiveIndex = _.findLastIndex(this.array, (o) => {
            return o.active;
          });
          // 如果当前为激活的最后一项则为黑色实心圆
          if (lastActiveIndex === index) {
            status = "current";
          } else {
            status = "active";
          }
        }
        return {
          text: item.text,
          status,
        };
      });
    },
  },
  mounted() {
    // 要求不是整个组件居中，而是要求组件进度条那部分居中,也就是要求和下方没字的时候进图条位置一直。所以只能计算属性，相对位置挪一下了
    const firstProgress = this.$refs.progressItems[0].clientWidth;
    const lastProgress =
      this.$refs.progressItems[this.$refs.progressItems.length - 1].clientWidth;
    this.diff = (lastProgress - firstProgress) / 2 + 6;
  },
};
</script>
<style lang="less" scoped>
.progress-conponent {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  .progress-line-container {
    display: flex;
    position: absolute;
    top: 5px;
    left: 22px;
    width: calc(~"100% - 32px");
    .progress-line {
      height: 2px;
      flex: 1;
      &.active {
        background: #d8d8d8;
      }
      &.unactive {
        background-image: url("../../../../../public/images/cancel/Line@3x.png");
        background-repeat: repeat-x;
        background-size: contain;
      }
    }
  }
  .progress-circle-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .progress-item {
      display: flex;
      align-items: center;
      flex-direction: column;
      &.active {
        color: #8c8c8c;
        .circle {
          background: #8c8c8c;
        }
      }
      &.current {
        .circle {
          background: #4b4b4b;
        }
        color: #4b4b4b;
      }
      &.unactive {
        .circle {
          border: 2px solid #e1e1e1;
          background: white;
        }
        color: #e1e1e1;
      }
      .circle-border {
        height: 16px;
        width: 16px;
        display: flex;
        justify-content: center;
        background: white;
        z-index: 1;
        .circle {
          height: 12px;
          width: 12px;
          border-radius: 50%;
        }
      }
      .status-text {
        margin-top: 13px;
        font-size: 10px;
        font-weight: 700;
      }
    }
  }
}
</style>
